var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_555",
    "data-name": "Group 555",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.482,
    viewBox: "0 0 15.482 15.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M0,0H15.482V15.482H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M2,6.87H14.256a.645.645,0,0,1,.645.645v6.451a.645.645,0,0,1-.645.645H2.645A.645.645,0,0,1,2,13.966ZM2.645,3h9.676V5.58H2V3.645A.645.645,0,0,1,2.645,3Zm7.741,7.1v1.29h1.935V10.1Z",
    transform: "translate(-0.71 -1.065)",
    fill: "#f5c839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveWalletIcon);
export default __webpack_public_path__ + "static/media/activeWalletIcon.954214fe54102e31d6afcd669bf480f0.svg";
export { ForwardRef as ReactComponent };